import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="2lp55ythgz6uq">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="26xmrx1867me0">
        <header className="text-center" data-id="element-86" data-mp="26wleiq3omnt4">
          <h2 className="font-display text-2xl font-bold sm:text-4xl" data-id="element-87" data-mp="2bwh9jzuej4wj">
            ¿Cuánto tiempo más vas a esperar a que tu cuerpo “se acomode solo”?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88" data-mp="21zcxisu9sptg">
            Probaste de todo, pero la pesadez vuelve, la energía baja y el hambre se desordena.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89" data-mp="1o1ocnl07dioe">
            No es falta de voluntad: te falta un sistema claro para ordenar tu rutina.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="3ie4febtsieoi">
          {painPoints.map((point, index) => <Reveal key={point} from="left" delay={index * 50} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91" data-mp="3nbmqa7rdb3z5" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" data-mp="1yykgxn5yfq5g" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93" data-mp="1tzhjoow7uo81">
                {point}
              </p>
            </Reveal>)}
        </div>
        
        <p className="mt-8 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94" data-mp="23sokrxjxbi2b">
          ¿Y si en 10 días pudieras entender qué pasa y empezar a ordenarlo?
        </p>
      </div>
    </section>;
}